import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: Index
  },
  {
    path: '/',
    name: 'classroom',
    component: () =>
            import('../views/classroom/classroom.vue')  
  },
  {
    path:'/demoScroll',
    name:'demoScroll',
    component:() =>
       import('../views/classroom/demoScroll.vue') 
  },
  {
    path:'/categoryTab',
    name:'categoryTab',
    component:() =>
      import('../views/classroom/categoryTab.vue') 
  },
  {
    path:'/more',
    name:'more',
    component: () =>
            import('../views/classroom/more.vue'),
    meta:{
      title: '全部视频',
      keepAlive: true
    }
  },
  {
    path:'/categories',
    name:'categories',
    component: () =>
            import('../views/classroom/categories.vue'),
  },
  {
    path:'/subCategories',
    name:'subCategories',
    component: () =>
            import('../views/classroom/subCategories.vue'),
  },
  {
    path:'/tabZujian',
    name:'tabZujian',
    component: () =>
              import('../components/tabZujian.vue')    
  },
  {
    path: '/classification',
    name: 'classification', // 分类
    component: () =>
            import('../views/index/classification/classification.vue')
  },
  {
    path: '/curriculumSchedule',
    name: 'curriculumSchedule', // 媒体列表
    component: () =>
            import('../views/index/curriculum_schedule/curriculum_schedule.vue')
  },
  {
    path: '/mediaRecommendationDetail',
    name: 'mediaRecommendationDetail', // 媒体列表详情
    component: () =>
            import(
              '../views/index/media_recommendation/media_recommendation_detail.vue'
            )
  },
  {
    path: '/alliance',
    name: 'alliance',
    component: () => import('../views/alliance/alliance.vue')
  },
  {
    path: '/merchant',
    name: 'merchant', // 商家介绍
    component: () => import('../views/alliance/merchant/merchant.vue')
  },
  {
    path: '/membershipDetail',
    name: 'membershipDetail', // 商家介绍
    component: () => import('../views/alliance/membership/detail.vue')
  },
  {
    path: '/user',
    name: 'user',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
            import(/* webpackChunkName: "mine" */ '../views/user/user.vue')
  },
  {
    path: '/helpCenter',
    name: 'helpCenter', // 帮助中心
    component: () => import('../views/user/helpCenter.vue')
  },
  {
    path: '/vipPrivilege',
    name: 'vipPrivilege', // vip会员
    component: () => import('../views/user/vip_privilege/vip_privilege.vue')
  },
  {
    path: '/vipPrivilegePayment',
    name: 'vipPrivilegePayment', // vip会员续费
    component: () =>
            import('../views/user/vip_privilege/vip_privilege_payment.vue')
  },
  {
    path: '/coupon',
    name: 'coupon', // vip会员 使用卡券
    component: () =>
            import('../views/user/my_card_package/coupon.vue')
  },
  {
    path: '/personalInformation',
    name: 'personalInformation', // 个人中心 个人资料
    component: () =>
            import('../views/user/personal_information/personal_information.vue')
  },
  {
    path: '/replacePhone',
    name: 'replacePhone', // 个人中心 更换手机号
    component: () =>
            import('../views/user/personal_information/replace.vue')
  },
  {
    path: '/confirm',
    name: 'confirm', // 个人中心 确认更换手机号
    component: () =>
            import('../views/user/personal_information/confirm.vue')
  },
  {
    path:'/dy/*',
    name:'dy',
    component:() =>
       import('../views/dy/index.vue') 
  },
  {
    path:'/z/*',
    name:'z',
    component:() =>
       import('../views/dy/zxy.vue') 
  },
  {
    path:'/playVideo',
    name:'playVideo',
    component:() =>
       import('../views/playVideo/playVideo.vue') 
  },
  {
    path:'/playVideoBig',
    name:'playVideoBig',
    component:() =>
       import('../views/playVideo/playVideoBig.vue') 
  },
  {
    path:'/yx/*',
    name:'yx',
    component:() =>
       import('../views/dy/yx.vue') 
  },
  {
    path:'/zxy/*',
    name:'zxy',
    component:() =>
       import('../views/dy/zxyQr.vue') 
  },
  {
    path:'/buyYx',
    name:'buyYx',
    component:() =>
       import('../views/dy/buyYx.vue') 
  }
 
]

const router = new VueRouter({
    // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
